<template>
  <div class="drawer" style="height: calc(100vh - 60px);">
    <div v-show="isHistoryShow" class="drawer-meng" @click="isHistoryShow = false"></div>
    <CommonSearch
      ref="CommonSearch"
      style="border-bottom:none"
      :search-label="searchLabel"
      :show-history-dialog="isHistoryShow"
      @showHistory="isHistoryShow = true"
      @doSearch="defaultSearch"
      @goBack="goBack"
      @changeSearchType="changeSearchType"
    ></CommonSearch>
    <div v-if="isSearch" v-loading="loading" class="drawer-content">
      <ProjectList
        :projects="searchProjects"
        :project="project"
        :fold="projectListFold"
        @modifyFold="modifyFold"
        @chooseProject="getProjectDetail"
      ></ProjectList>
    </div>
    <div v-if="project._id" class="drawer-content">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="breadcrumb-item" style="cursor:pointer" @click.native="activeTag = ''">
            <!-- <i class="el-icon-folder breadcrumb-icon"></i> -->
            <div style="display:inline-block">
              <img src="../../constant/icon/file.png" class="breadcrumb-icon" style="width:20px" />
              <span style="color:#262626;font-weight:600;">项目信息</span>
            </div>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeTag" class="breadcrumb-item">{{ activeTag }}</el-breadcrumb-item>
        </el-breadcrumb>
        <span v-if="activeTag==='快速介绍项目'" class="svg-text-btn" type="text" @click="activeTag = ''">
          <svg t="1621590925010" fill="#409EFF" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17885" width="12" height="12"><path d="M728.1 376H125l293.3-260.7c14.2-12.6 15.5-34.4 2.9-48.6-12.6-14.2-34.3-15.5-48.6-2.9L13.1 383.4c-8 6.3-13.1 16-13.1 27V412.1c0.4 9.2 4.6 17.9 11.5 24l361 320.9c6.6 5.8 14.7 8.7 22.8 8.7 9.5 0 18.9-3.9 25.7-11.5 12.6-14.2 11.3-35.9-2.9-48.6L124.8 444.8H728.2c125.2 0 227 101.8 227 227s-101.8 227-227 227H331.6c-19 0-34.4 15.4-34.4 34.4s15.4 34.4 34.4 34.4h396.5c163.1 0 295.8-132.7 295.8-295.8C1023.9 508.7 891.2 376 728.1 376z m0 0" p-id="17886"></path></svg>
          返回
        </span>
        <!-- <el-button v-if="activeTag" class="text-btn-p0" type="text" @click="showProjectTag = !showProjectTag">
          <i :class="showProjectTag ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
          {{ showProjectTag ? '收起' : '展开' }}
        </el-button> -->
      </div>
      <div v-if="showProjectTag" class="mb10">
        <ProjectDetailToTag
          ref="ProjectDetailToTag"
          :project="project"
          :company="company"
          :active-tag="activeTag"
          @chooseTag="chooseTag"
          @changeSearch="changeSearch"
        ></ProjectDetailToTag>
      </div>
      <div v-if="activeTag">
        <BasicInfo v-if="activeTag === '岗位基本信息'" ref="BasicInfo" :company="company" :project="project" @quickEdit="quickEdit"></BasicInfo>
        <QuickIntro v-else-if="activeTag === '快速介绍项目'" ref="QuickIntro" :company="company" :project="project" @quickEdit="quickEdit"></QuickIntro>
        <JobAdvantage v-else-if="activeTag === '岗位补充信息'" ref="JobAdvantage" :project="project" @quickEdit="quickEdit"></JobAdvantage>
        <InterviewCoach v-else-if="activeTag === '面试辅导'" ref="InterviewCoach" :project="project" @quickEdit="quickEdit"></InterviewCoach>
        <OrderAnalyze v-else-if="activeTag === '必成单分析'" ref="OrderAnalyze" :project="project" @quickEdit="quickEdit"></OrderAnalyze>
        <RadishPic v-else-if="activeTag === '用人画像'" ref="RadishPic" :company="company" :project="project" @quickEdit="quickEdit"></RadishPic>
        <SearchDirection v-else-if="activeTag === '寻访方向'" ref="SearchDirection" :project="project" :company="company" @quickEdit="quickEdit" ></SearchDirection>
        <CompanyBack v-else-if="activeTag === '客户背景'" ref="CompanyBack" :company="company" :project="project" @quickEdit="quickEdit"></CompanyBack>
        <Remark v-else-if="activeTag === '项目沟通备注'" ref="Remark" :project="project"></Remark>
        <Attachment v-else-if="activeTag === '项目附件'" ref="Attachment" :project="project"></Attachment>
        <!-- <JobJd v-else-if="activeTag === '岗位JD'" ref="JobJd" :project="project"></JobJd> -->
        <!-- <ProjectCoach v-else-if="activeTag === '项目辅导'" ref="ProjectCoach" :project="project"></ProjectCoach> -->
        <!-- <RadishPicAnalyse v-else-if="activeTag === '人才画像分析'" ref="RadishPicAnalyse" :project="project"></RadishPicAnalyse> -->
        <!-- <NewJobRequirement v-else-if="activeTag === '岗位要求'" ref="NewJobRequirement" :project="project"></NewJobRequirement> -->
        <div class="edit-btn-box">
          <el-button size="mini" @click="toProject">编辑</el-button>
          <!-- <span class="radish-btn radish-btn-primary radish-btn-small" @click="toProject">编辑</span> -->
        </div>
      </div>
      <!-- <div class="default-project">
          <p>您要找的是不是以下公司：</p>
          <p v-for="project in defaultProject"
            :key="project"
            class="link-item"
            @click="search({type:'公司',keywords:project})">
            {{`${project}`}}
          </p>
        </div> -->
    </div>
    <div v-else class="default-project">
      <p>本周重点项目：</p>
      <p
        v-for="item in defaultProject"
        :key="item._id"
        class="link-item"
        @click="defaultSearch({ type: '项目', keywords: item.项目名称 })"
      >
        {{ `${item.客户公司 ? `${item.客户公司}-` : ''}${item.部门 ? `${item.部门}-` : ''}${item.项目名称}` }}
      </p>
    </div>
    <div v-if="project._id && !activeTag" style="padding: 0 25px;">
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="breadcrumb-item">
            <div style="display:inline-block">
              <img src="../../constant/icon/file.png" class="breadcrumb-icon" style="width:20px" />
              <span style="color:#262626;font-weight:600;">项目进展</span>
            </div>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div>
        <ProjectSteps :project="project"></ProjectSteps>
        <!-- <p v-for="project in companyProjects" :key="project._id" class="link-item" @click="openProject(project)">
          {{`${project.部门?`${project.部门}-`:''}${project.项目名称}（${project.客户公司}）`}}
        </p> -->
      </div>
    </div>
    <EditDialog ref="EditDialog"></EditDialog>
  </div>
</template>
<script>
import { searchLabel2Value, searchPlaceHolder } from '../../constant/utils'
import CommonSearch from '../../searchBar/CommonSearch'
import ProjectList from './ProjectList'
import ProjectDetailToTag from './ProjectDetailToTag'
import BasicInfo from './BasicInfo'
// import JobRequirement from './JobRequirement'
// import KeyRequirement from './KeyRequirement'
// import PositionStatement from './PositionStatement'
import RadishPic from './RadishPic'
// import DepartmentDeatil from './DepartmentDeatil'
// import SellingPoints from './SellingPoints'
// import Question from './Question'
import SearchDirection from './SearchDirection'
import Remark from './Remark'
import Attachment from './Attachment'
import CompanyBack from './CompanyBack'
// import JobJd from './JobJd'
import JobAdvantage from './JobAdvantage'
import InterviewCoach from './InterviewCoach'
import OrderAnalyze from './OrderAnalyze'
// import ProjectCoach from './ProjectCoach'
// import RadishPicAnalyse from './RadishPicAnalyse'
// import NewJobRequirement from './NewJobRequirement'
import ProjectSteps from '../../../../../project/src/components/projectProgress/ProjectSteps'
import QuickIntro from './QuickIntro'
import EditDialog from '../company/EditDialog'

import { tags } from '../../../../../project/src/constant/type'

const searchLabel = '项目'
export default {
  components: {
    CommonSearch,
    ProjectList,
    ProjectDetailToTag,
    BasicInfo,
    Attachment,
    // JobRequirement,
    // KeyRequirement,
    // PositionStatement,
    SearchDirection,
    RadishPic,
    // DepartmentDeatil,
    Remark,
    // SellingPoints,
    // Question,
    ProjectSteps,
    CompanyBack,
    // JobJd,
    JobAdvantage,
    InterviewCoach,
    OrderAnalyze,
    // ProjectCoach,
    // RadishPicAnalyse,
    // NewJobRequirement,
    QuickIntro,
    EditDialog,
  },
  data() {
    return {
      searchLabel: searchLabel,
      searchType: searchLabel2Value[searchLabel],
      placeHolder: searchPlaceHolder[searchLabel],
      isHistoryShow: false,
      searchProjects: [],
      project: {},
      company: {},
      isSearch: false,
      loading: false,
      projectListFold: false,
      activeTag: '',
      showProjectTag: true,
      projectProjects: [],
      defaultProject: [],
      tableFields: [
        {
          children: [
            { label: '地域', field: '地域' },
            { label: '业绩', field: '业绩' },
            { label: '专业能力', field: '专业能力' },
          ],
        },
        {
          children: [
            { label: '性别', field: '性别' },
            { label: '稳定性', field: '稳定性' },
            { label: '语言能力', field: '语言能力' },
          ],
        },
        {
          children: [
            { label: '年龄', field: '年龄' },
            { label: '来源公司', field: '来源公司' },
            { label: '领导能力', field: '领导能力' },
          ],
        },
        {
          children: [
            { label: '学历要求', field: '学历要求' },
            { label: '来源行业', field: '来源行业' },
            { label: '心态/性格', field: '心态/性格' },
          ],
        },
        {
          children: [
            { label: '学历标签', field: '学历标签' },
            { label: '平台', field: '平台' },
            { label: '个人风格', field: '个人风格' },
          ],
        },
        {
          children: [
            { label: '工作经验', field: '工作经验' },
            { label: '', field: '' },
            { label: '', field: '' },
          ],
        },
      ]
    }
  },
  computed:{
    tags() {
      const obj = {}
      tags.forEach(tag => {
        obj[tag.label] = tag.children
      })
      return obj
    },
  },
  // watch: {
  //   activeTag(newValue, oldValue) {
  //     this.showProjectTag = !newValue
  //   },
  // },
  mounted() {
    this.init()
    const fields = []
    const { tableFields } = this
    tableFields.forEach(tr => {
      tr.children.forEach(td => {
        if (td.label) fields.push(td.field)
      })
    })
    this.analyseFields = fields
  },
  methods: {
    init() {
      this.keywords = ''
      this.result = []
      this.loading = false
      this.defaultProject = []
      this.getDefaultData()
    },
    changeSearch(params) {
      this.$emit('changeSearch',params)
    },
    goBack() {
      this.$emit('goBack')
    },
    quickEdit(params){
      this.$refs.EditDialog.open(params)
    },
    async getDefaultData() {
      const res = await app
        .service('project')
        .list({ query: {}, page: 1, limit: 10, sort: { 优先级: -1, createdAt: -1 }, isPined: true })
      if (res.status === 'success') this.defaultProject = res.data
      else this.$message.error(res.msg)
    },
    chooseTag(tag) {
      this.activeTag = tag
    },
    changeSearchType(type) {
      this.$emit('searchTypeChange', type)
    },
    setSearchHistory() {
      this.searchHistory = localStorage.searchHistory ? JSON.parse(localStorage.searchHistory) : {}
      if (!this.searchHistory[this.searchType]) this.searchHistory[this.searchType] = []
      if (!this.searchHistory[this.searchType].includes(this.keywords)) {
        this.searchHistory[this.searchType].unshift(this.keywords)
        localStorage.searchHistory = JSON.stringify(this.searchHistory)
      }
    },
    async doSearch(id) {
      if (!this.keywords) return this.$message.info('请输入搜索内容')
      this.setSearchHistory()
      this.isHistoryShow = false
      this.loading = true
      try {
        await app.service('misc').insertSearchHistory({ type: searchLabel, keywords: this.keywords })
      } catch (e) {}
      const res = await app.service('project').search({ type: '项目', keywords: this.keywords, id:id })
      if (res.status === 'success') {
        this.isSearch = true
        this.searchProjects = res.data
        if (this.searchProjects.length !== 0) {
          const val = this.searchProjects.find(v => v.简称 === this.keywords || v.公司名称 === this.keywords)
          this.getProjectDetail({ id: val ? val._id : this.searchProjects[0]._id, type: 'auto' })
        }
      } else this.$message.error(res.msg)
      this.loading = false
    },
    defaultSearch({ type, keywords, result, id }) {
      this.searchType = type
      this.keywords = keywords
      this.$refs.CommonSearch.keywords = keywords
      if (result) {
        this.result = result
      } else {
        this.$nextTick(() => {
          this.doSearch(id)
        })
      }
    },
    async getProjectDetail({ id, type }) {
      try {
        const ind = this.searchProjects.findIndex(v=>v._id===id)
        const obj = this.searchProjects[ind]
        this.searchProjects.splice(ind,1)
        this.searchProjects.unshift(obj)
        const data = await app.service('project').fetch(id)
        const pipelineRes = await this.$axios.post(`${window.host}/projects/newPipelines`, {
          pids: [id],
        })
        this.project = Object.assign({}, data, pipelineRes.data[0])
        this.project['可能的问题及应对'] = (this.project['可能的问题及应对'] || []).filter(v=>v.Q||v.A)
        this.projectListFold = type !== 'auto'
        this.showProjectTag = true
        this.activeTag = ''
        this.getProjectFiles()
        this.getCompany()
        this.getHr()
        this.getInterviewer()
        this.getTypicalRadish()
        this.getProjectImage()
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async getTypicalRadish() {
      const ids = this.project['典型人才']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.$set(this.project,'typicalRadishes',res.data)
      } else this.$set(this.project,'typicalRadishes',[])
    },
    async getInterviewer(){
      const ids = this.project['关键面试人'] || []
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.$set(this.project,'interviewer',res.data)
      } else this.$set(this.project,'interviewer',[])
    },
    async getHr(){
      const projectHrids = this.project['对接hr'] || []
      if (!projectHrids || projectHrids.length === 0) return this.$set(this.project,'contact',[])
      const res1 = await app.service('company').getCompanyHrsByIds(projectHrids || [])
      const res2 = await app.service('radish').simpleList({
          query: {_id: {$in: projectHrids}},
          fields: { 姓名: 1, 手机: 1, 座机:1, 邮箱:1, 公司: 1, 部门: 1, 目前职位:1, 职能模块: 1, 职级: 1 },
        })
      const contact = []
      if(res1.status === 'success') contact.push(...res1.data)
      if(res2.status === 'success') {
        res2.data.forEach(v=>{
          v.rid=v._id
        })
        contact.push(...res2.data)
      }
      this.$set(this.project,'contact',contact)
    },
    async getProjectFiles() {
      const { data } = await app.service('file').projectFiles({ query: { projectId: this.project._id } })
      this.$set(this.project, '附件', data)
    },
    async getCompany() {
      const companyName = this.project.客户公司
      if (!companyName) return
      try {
        const res = await app.service('company').getCompanyByName(companyName)
        this.company = Object.assign({}, res.result)
      } catch (e) {
        console.error(e)
      }
    },
    // async getProjectProject(project) {
    //   const res = await app.service('misc').defaultProjectProject({ project })
    //   if (res.status === 'success') this.projectProjects = res.data
    //   else this.$message.error(res.msg)
    // },
    modifyFold() {
      this.projectListFold = !this.projectListFold
    },
    toProject() {
      window.open(`${window.origin}#/project20/${this.project._id}?defaultActiveTab=详情`)
    },
    getProjectImage() {
      const projectImageMap = {
        地域: '地域',
        性别: '性别',
        年龄: '年龄要求',
        学历要求: '学历要求',
        学历标签: '倾向学历',
        工作经验: '工作经验',
        业绩: '业绩',
        稳定性: '稳定性',
        来源公司: '目标公司',
        来源行业: '目标行业',
        平台: '平台',
        专业能力: '标签',
        语言能力: '标签',
        领导能力: '标签',
        '心态/性格': '标签',
        个人风格: '标签',
      }
      const tagTranslate = {
        '心态/性格': '心态、个性',
        领导能力: '领导',
        专业能力: '专业因素',
      }
      const obj = {}
      this.analyseFields.forEach(v => {
        const field = projectImageMap[v]
        if (v === '年龄') {
          const arr = (this.project['年龄要求'] || []).filter(a => a)
          obj[v] = arr.length > 0 ? `${arr.join('-')}岁` : ''
        } else if (field === '标签') {
          const arr = (this.project['标签'] || []).filter(a => (this.tags[tagTranslate[v] || v] || []).includes(a))
          obj[v] = arr
        } else {
          obj[v] = this.project[field]
        }
      })
      this.$set(this.project,'analyse',obj)
    },
  },
}
</script>
<style>
.breadcrumb .el-breadcrumb {
  font-size: 12px;
  display: flex;
  align-items: center;
}
</style>
<style scoped>
.breadcrumb {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.svg-text-btn{
  cursor: pointer;
  color: #409eff;
  display: flex;
  align-items: center;
}
.edit-btn-box {
  display: flex;
  padding: 0px 10px 10px;
  justify-content: flex-end;
}
.link-item {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 10px;
  color: #409eff;
  cursor: pointer;
}
.default-project {
  padding: 10px;
}
</style>
<style scoped src="../../constant/css/drawer.css"></style>
